import { type_list } from "./fields";
const types_hash = Object.assign(
  ...type_list.map((obj) => ({ [obj.value]: obj.title }))
);

const util = {
  groups: [
    { code: "01", name: "图书", property: "SelfMade" },
    { code: "02", name: "周边", property: "SelfMade" },
    { code: "08", name: "配件", property: "SelfMade" },
    { code: "04", name: "礼盒", property: "SelfMade" },
    { code: "05", name: "课程", property: "Service" },
    { code: "06", name: "会员/积分", property: "Service" },
    { code: "07", name: "虚拟赠品", property: "Service" },
    { code: "03", name: "包装耗材", property: "SelfMade" },
  ],
  getStock(id) {
    return new Promise((resolve, reject) => {
      Util.ajax
        .get(Util.api.stock_detail, {
          params: { id: id },
        })
        .then((response) => {
          return response.data;
        })
        .then((res) => {
          if (res.code === 1) {
            resolve(res.data);
          } else {
            reject({ message: res.msg });
          }
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  getTaxRates() {
    return new Promise((resolve, reject) => {
      Util.ajax
        .get(Util.api.get_all_tax_rate, {
          params: {},
        })
        .then((response) => {
          return response.data;
        })
        .then((res) => {
          if (res.code === 1) {
            resolve(res.data);
          } else {
            reject({ message: res.msg });
          }
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  getStockUnits() {
    return new Promise((resolve, reject) => {
      Util.ajax
        .get(Util.api.get_all_stock_unit, {
          params: {},
        })
        .then((response) => {
          return response.data;
        })
        .then((res) => {
          if (res.code === 1) {
            resolve(res.data);
          } else {
            reject({ message: res.msg });
          }
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  getInTypeName(in_type) {
    const type_name = types_hash[in_type];
    return type_name ? type_name : "未定义入库类型";
  },
  getStockTeams() {
    return new Promise((resolve, reject) => {
      Util.ajax
        .get(Util.api.stock_teams, {
          params: {},
        })
        .then((response) => {
          return response.data;
        })
        .then((res) => {
          if (res.code === 1) {
            resolve(res.data);
          } else {
            reject({ message: res.msg });
          }
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
};
util.groups_hash = {};
util.groups.forEach((group) => {
  util.groups_hash[group.code] = group.name;
});
util.getGroupName = (code) => {
  return util.groups_hash[code];
};

util.alert_types = [
  { label: "每天", value: "every_day" },
  { label: "每周", value: "every_week" },
];
const alert_types_hash = Object.assign(
  ...util.alert_types.map((obj) => ({ [obj.value]: obj.label }))
);
util.getAlertTypeName = (val) => {
  const name = alert_types_hash[val];
  return name ? name : "未定义提醒类型";
};

util.new_stock_dosage = {
  stock_id: 0,
  qty: 0,
  remark: "",
  stock_uid: "",
  stock_name: "",
  team_id: 0,
};
util.new_stock = () => ({
  outsourcing: false,
  outsource_relation: "",
  drop_shipping: false,
  cost_unit_price: null,
  use_team_id: "",
  del_reason: "",
  is_iteration: false,
  parent_id: 0,
  version: 0,
  product_type_id: null,
  product_type_name: "",
  is_gift: false,
  apply_patent: false,
  is_assemble: false,
  team_id: 0,
  apply_user: "",
  apply_user_id: 0,
  fill_user: "",
  fill_user_id: 0,
  name: "",
  name_en: "",
  classification: "",
  group: "",
  property: "",
  brand: "",
  series: "",
  keyword: "",
  spec: "",
  stock_unit_id: 0,
  launch_date: "",
  stock_img: "",
  uid: "",
  tax_code_id: 0,
  company_code: "",
  desc: "",
  del: false,
  stock_dosages: [util.new_stock_dosage],
  auto_balance: true,
  payee_company_contact_id: null,
  payee_company_id: null,
  _isbn_status: null,
  isbn: null,
  isbn_delay: {
    days: null,
  },
  imported: "",
  cya_spu_id: null,
  cya_spu_name: null,
});

util.new_product_type = {
  name: "",
  level: 1,
  parent_id: 0,
};

export default util;
